// src/formatters/index.js
// Formatters — extracted from index.html (v105.x sprint, auto-generated header).
// Bundled by esbuild into dist/formatters.js. The HTML loads it via
//   <script src="dist/formatters.js"></script>
// and call sites use `Formatters.<sub>.<fn>()` (e.g.
//   Formatters.format.escapeHtml()
// ).
//
// Backwards compat: index.html's trailing script block re-exposes the
// moved functions on window so existing call sites — both inline JS and
// onclick="" attributes — keep working without HTML edits.
//
// Free variables (DB, currentUser, currentStore, escapeHtml, WORKER_URL,
// fetch, console, document, window, ...) live in the inline globals
// scope of index.html. esbuild leaves them as bare references at runtime.

// ── format ─────────────────────────────────────────────
export const format = {};

function escapeHtml(s){
  return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
    return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
  });
}
format.escapeHtml = escapeHtml;

function formatToilDH(h) {
  if (!h) return '0h';
  var sign = h < 0 ? '-' : '+';
  var abs = Math.abs(h);
  var days = Math.floor(abs / 8);
  var hrs  = Math.round((abs - days * 8) * 10) / 10;  // 1dp
  var hrsStr = (hrs % 1 === 0) ? String(hrs) : hrs.toFixed(1);
  if (days === 0) return sign + hrsStr + 'h';
  if (hrs === 0)  return sign + days + 'd';
  return sign + days + 'd ' + hrsStr + 'h';
}
format.formatToilDH = formatToilDH;

function formatRelativeTime(isoStr) {
  if (!isoStr) return '';
  var then = new Date(isoStr).getTime();
  var diffMs = Date.now() - then;
  var diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 1)  return 'just now';
  if (diffMin < 60) return diffMin + ' min ago';
  var diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24)  return diffHr + ' hr ago';
  return Math.floor(diffHr / 24) + ' days ago';
}
format.formatRelativeTime = formatRelativeTime;

function formatDDMMYYYY(d) {
  return String(d.getUTCDate()).padStart(2, '0') + '/' +
         String(d.getUTCMonth() + 1).padStart(2, '0') + '/' +
         d.getUTCFullYear();
}
format.formatDDMMYYYY = formatDDMMYYYY;

// D-cust2 (per-tenant currency): a prefix for the tenant's currency. ELC has
// ALWAYS shown symbol-less numbers ("1,234"), so AED (and no-config) stays
// symbol-less — byte-identical. A tenant on another currency (e.g. GBP) gets
// its symbol ("£1,234"). Symbol-less currencies (AED) keep the legacy look.
var CURRENCY_SYMBOLS = { GBP: '£', USD: '$', EUR: '€', AED: '', IQD: 'IQD ' };
function currencyPrefix(){
  try {
    var cur = (typeof DB !== 'undefined' && DB.currency) ? DB.currency() : 'AED';
    if (!cur || cur === 'AED') return '';   // ELC legacy: no symbol
    return CURRENCY_SYMBOLS[cur] != null ? CURRENCY_SYMBOLS[cur] : (cur + ' ');
  } catch (e) { return ''; }
}
format.currencyPrefix = currencyPrefix;

function formatCurrency(n){
  if (n == null || isNaN(n)) return '—';
  return currencyPrefix() + Math.round(Number(n)).toLocaleString();
}
format.formatCurrency = formatCurrency;

function formatCurrencyShort(n){
  if (n == null || isNaN(n)) return '—';
  var v = Math.round(Number(n));
  // Keep the full number for clarity — abbreviation (k/M) tested poorly
  // with retail managers who want exact numbers, not approximations.
  return currencyPrefix() + v.toLocaleString();
}
format.formatCurrencyShort = formatCurrencyShort;

function formatPct(n){
  if (n == null || isNaN(n)) return '—';
  var sign = n >= 0 ? '+' : '';
  return sign + (Number(n) * 100).toFixed(1) + '%';
}
format.formatPct = formatPct;

function formatKpiDate(dateStr){
  // dateStr is YYYY-MM-DD. Display as "Thu 31 Dec 2026" — short weekday,
  // day, short month, full year. Year matters once historical data is
  // loaded — without it "Thu 31 Dec" is ambiguous between years.
  var parts = dateStr.split('-');
  if (parts.length !== 3) return dateStr;
  var d = new Date(Date.UTC(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2])));
  var DAY = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  return DAY[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MON[d.getUTCMonth()] + ' ' + d.getUTCFullYear();
}
format.formatKpiDate = formatKpiDate;
